export const TAGS = [
  { key: "임종 전", value: "before" },
  { key: "장례 중", value: "ongoing" },
  { key: "장례 후", value: "after" },
  { key: "기타", value: "etc" },
];
